import { render, staticRenderFns } from "./ProductionListItem.vue?vue&type=template&id=7ef6005e&"
import script from "./ProductionListItem.vue?vue&type=script&lang=js&"
export * from "./ProductionListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductionListItem.vue"
export default component.exports